export default __webpack_public_path__ + "static/media/ankit saini.ba0de421.jpeg";